import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, bindActionCreators, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import { AppReducers } from './App.reducers';
import AppContainers  from './App.containers';


window.__appointment = window.__appointment || {};
const preloadState = window.__appointment.preloadState || {};

const listData = {...window.__appointment.preloadState},
    {products, employees} = listData;

let newProducts = products.filter(e => e.display);   
let newEmployees = employees.filter(e => e.display);  
let newState = {
    ...preloadState,
    shop: {
      ...preloadState.shop,
      apiVersion: 'v1.5'
    },
    products: newProducts,
    employees: newEmployees
}
const store = createStore(AppReducers, newState, composeWithDevTools(applyMiddleware(thunk)));

// register redux's actions so we can invoke them from javascript

// prevent not reload page when back on safari ios

window.onpageshow = function(event) {
    if (event.persisted) {
        window.location.reload() 
    }
};

window.__appointment = {
    ...window.__appointment,
    reduxActions: bindActionCreators({} , store.dispatch),
};
if (document.getElementById('appContainer')) {
    ReactDOM.render(
        <Provider store={store}>
            <AppContainers />
        </Provider>,
        document.getElementById('appContainer')
    );
}